import TopUpImage from '../../assets/images/topup.webp';
import NumberOneCircleIcon from '../../components/shared/Icons/NumberOneCircleIcon';
import NumberTowCircleIcon from '../../components/shared/Icons/NumberTowCircleIcon';
import NumberThreeCircleIcon from '../../components/shared/Icons/NumberThreeCircleIcon';
import InstructionsScreen from '../../components/shared/InstructionsScreen/InstructionsScreen';
import InstructionsSkeleton from '../../components/shared/InstructionsSkeleton/InstructionsSkeleton';
import { useEffect, useState } from 'preact/hooks';
import CardService from '../../services/card.service';
import NavigationUtils from '../../utils/navigation.utils';
import { CardProvider } from '../../clients/card.networks';

const TopupMethods = {
  [CardProvider.MEEZA]: {
    image: TopUpImage,
    title: 'Top up your {card name} card in 3 easy steps!',
    subtitle: 'Transactions are instant and free.',
    instructions: [
      {
        icon: <NumberOneCircleIcon />,
        title: 'Visit your nearest deposit - enabled ATM',
      },
      { icon: <NumberTowCircleIcon />, title: 'Insert your card' },
      {
        icon: <NumberThreeCircleIcon />,
        title: 'Follow the onscreen instructions for a deposit!',
      },
    ],
    cta: {
      text: 'See available banks',
      onClick: () => {
        NavigationUtils.navigate(
          `${NavigationUtils.Routes.TOPUP_DETAIL}/atm/listing`,
        );
      },
    },
  },

  default: {
    image: TopUpImage,
    title: 'Top up your {card name} card at Misr Bank!',
    subtitle: 'Transactions are instant and free.',
    instructions: [
      {
        icon: <NumberOneCircleIcon />,
        title: 'Visit your nearest Misr Bank deposit - enabled ATM',
      },
      { icon: <NumberTowCircleIcon />, title: 'Insert your card' },
      {
        icon: <NumberThreeCircleIcon />,
        title: "Follow Misr Bank's onscreen instructions for a deposit!",
      },
    ],
  },
};

export default function AtmInstructionsPage({
  organization: organizationCode,
}) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(TopupMethods.default);

  useEffect(() => {
    CardService.getAtms(organizationCode)
      .then(body => {
        setLoading(false);
        setData(TopupMethods[body.data.network] ?? TopupMethods.default);
        localStorage.setItem('banks-list', JSON.stringify(body.data.banks));
      })
      .catch(() => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  return (
    <>
      {loading ? (
        <InstructionsSkeleton />
      ) : (
        <InstructionsScreen
          organizationCode={organizationCode}
          image={data.image}
          title={data.title}
          subtitle={data.subtitle}
          instructions={data.instructions}
          cta={data.cta}
        />
      )}
    </>
  );
}
